import { React, useEffect, useRef, useState } from "react";

export const MyCheckbox = (props) => {
  let { childrenId, children, checked, setChecked, checkedId, setCheckedId } =
    props;

  function handleOnChange() {
    if (!checked.includes(children)){
      setChecked((checked) => [...checked, children]);
      setCheckedId((checkedId) => [...checkedId, childrenId]);
    }else{
      setChecked((checked) => checked.filter(item => item !== children));
      setCheckedId((checkedId) =>
        checkedId.filter((item) => item !== childrenId)
      );
    }
  }

  
  return (
    <label style={{ display: "flex", alignItems: "center", gap: "0.2em" }}>
      <input
        type="checkbox"
        value={children}
        onChange={handleOnChange}
        checked={checked.includes(children)}
        name={children}
      />
      <span>{children}</span>
    </label>
  );
};
